import React from 'react'
import { propTypes } from 'react-svg-spinner'

export const WaitRender = props => {
  const { timeout, withCountdown, renderCountdown, children } = props

  // State
  const [secondsLeft, setSecondsLeft] = React.useState(Math.ceil(timeout / 1000))
  const [isReady, setIsReady] = React.useState(false)

  // Lifecycle
  React.useEffect(
    () => {
      setIsReady(false)
      setSecondsLeft(Math.ceil(timeout / 1000))

      let countdownInterval

      if (withCountdown) {
        countdownInterval = setInterval(() => {
          setSecondsLeft(prevValue => prevValue - 1)
        }, 1000)
      }

      setTimeout(() => {
        if (setIsReady) {
          clearInterval(countdownInterval)
          setIsReady(true)
        }
      }, timeout)

      return () => {
        clearInterval(countdownInterval)
      }
    },
    [timeout, withCountdown],
  )

  // Render)
  if (!isReady) {
    if (withCountdown) {
      return renderCountdown ? renderCountdown(secondsLeft) : null
    }

    return null
  }

  return <React.Fragment>{children}</React.Fragment>
}

WaitRender.propTypes = {
  children: propTypes.children,
  timeout: propTypes.number,
  withCountdown: propTypes.bool,
  renderCountdown: propTypes.func,
}



// WEBPACK FOOTER //
// ./src/components/WaitRender/WaitRender.js